// @flow
import { authenticatedFetch } from '../../../api/request';

export default async function loadAllReactions() {
    const url = '/v5/messaging/reactions';
    return await authenticatedFetch(url);
}
